





























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import QTable from 'quasar/src/components/table/QTable.js';
import { PreferenceResourceType } from '@/modules/preferences/models/preference-resource.model'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import AdminPreferencesTableRow from '@/modules/preferences/components/admin/table/AdminPreferencesTableRow.vue'
import { getPreferencesColumnsInAdmin } from '@/modules/preferences/models/columns/preferences.column'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { PreferencesUpdateUseCase } from '@/modules/preferences/use-cases/admin/preferences-update.use-case'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'تنظیمات اعلانات مدیریت'
  },
  metaInfo: {
    title: 'تنظیمات اعلانات مدیریت'
  },
  components: { BaseButton, AdminLayout, TesTable }
})
export default class PreferencesPage extends Vue {

  constructor(
    private readonly preferencesUpdateUseCase: PreferencesUpdateUseCase
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() notifications!: PreferenceResourceType

  private isLoading: boolean = false

  private rowComponent = AdminPreferencesTableRow
  private columns: QTable['columns'] = getPreferencesColumnsInAdmin()
  private preferencesUpdateBtnLabel: string = 'ذخیره تغییرات'

  save() {
    this.preferencesUpdateUseCase.execute(this.notifications.data)
  }

}
